export const eventVsVenue = (eventValue, venueValue) => {
  if (eventValue === undefined && venueValue === undefined) {
    return "";
  }
  if (
    eventValue !== undefined &&
    eventValue !== null &&
    eventValue.length > 0
  ) {
    return eventValue;
  } else {
    return venueValue;
  }
};
